<template>
  <div>
    <v-alert
      v-model="BookmarkSuccess"
      class="fixedAlert"
      dismissible
      type="success"
    >
      Erfolgreich der Merkliste hinzugefügt.
    </v-alert>
    <v-alert
      v-model="BookmarkFailure"
      class="fixedAlert"
      dismissible
      type="error"
    >
      Diese Edition ist bereits in der Merkliste
    </v-alert>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <table class="w-100 editionTable ml-2 mt-4">
      <thead>
        <th>Edition</th>
        <th>Status</th>
        <th>Erstellt</th>
        <th>Aktiviert</th>
        <th>Benutzer</th>
        <th>Aktionen</th>
      </thead>
      <template v-for="(edition, index) in allEditions">
        <tr :key="`${index}-1`">
          <td>
            <router-link
              v-b-tooltip.hover
              :to="`/contract-overview/${contractId}/${versionId}/${edition.editionId}`"
            >
              {{ edition.editionId }}
            </router-link>
          </td>
          <td>
            {{ UniaGavConstants.UniaContractEditionState[edition.stateId] }}
          </td>
          <td>{{ edition.created | moment("DD.MM.YYYY HH:mm") }}</td>
          <td v-if="edition.activated">
            <template>
              {{ edition.activated | moment("DD.MM.YYYY HH:mm") }}
              <div class="checkbox-row">
                <span>Klauseländerungen vorhanden</span>
                <v-checkbox
                  v-if="edition.klauselnChanged !== null"
                  v-model="edition.klauselnChanged"
                  :disabled="true"
                  hide-details
                  class="compact-checkbox"
                />
                <strong
                  v-else
                  class="compact-questionmark"
                >?</strong>
              </div>
              <div class="checkbox-row">
                <span>Mindestlohnänderungen vorhanden</span>
                <v-checkbox
                  v-if="edition.tempDataMindestlohnrelevanteAenderungen !== null"
                  v-model="edition.tempDataMindestlohnrelevanteAenderungen"
                  :disabled="true"
                  hide-details
                  class="compact-checkbox"
                />
                <strong
                  v-else
                  class="compact-questionmark"
                >?</strong>
              </div>
            </template>
          </td>
          <td v-else />
          <td>{{ edition.ownerPrincipal }}</td>
          <td>
            <div class="editionActionWrapper row">
              <!-- <div class="editionAction">
                <button
                  v-b-tooltip.hover
                  type="button"
                  placement="bottom"
                  title="Lohnrechner mit allen Berechnungsdetails"
                  class="btn-secondary float-right w-100 h-100"
                >
                  <i class="fas fa-calculator" />
                </button>
              </div> -->
              <div class="editionAction">
                <button
                  v-b-tooltip.hover
                  type="button"
                  placement="bottom"
                  title="Vorschau der GAV-Details"
                  class="btn-secondary float-right w-100 h-100"
                  @click="openPreview(edition.editionId, edition)"
                >
                  <i class="fas fa-file-alt" />
                </button>
              </div>

              <div class="editionAction">
                <button
                  v-b-tooltip.hover
                  type="button"
                  placement="bottom"
                  title="Edition zur Merkliste hinzufügen"
                  class="btn-secondary float-right w-100 h-100"
                  @click="addEditionToBookmarks(currentVersionName, versionId, edition.editionId, contractId)"
                >
                  <i class="fas fa-tasks" />
                </button>
              </div>
              <div
                v-if="index == 0 && edition.stateId == 1 && $IsUserInRole('VertragsmanagementVerwaltung')"
                class="editionAction"
              >
                <button
                  v-b-tooltip.hover
                  v-b-modal.deleteEdition
                  type="button"
                  placement="bottom"
                  title="Edition löschen"
                  class="btn-danger float-right w-100 h-100"
                  @click="editionToDelete = edition.editionId"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
              <div
                v-if="index == 0 && edition.stateId == 1 && $IsUserInRole('VertragsmanagementVerwaltung')"
                class="editionAction"
              >
                <edition-publication
                  v-if="contractId && currentEditionId && versionId"
                  :contract-id="contractId"
                  :current-edition-id="edition.editionId"
                  :version-id="versionId"
                  :version-id-id="versionIdId"
                  @editionsChanged="$emit('editionsChanged')"
                />
              </div>
              <div
                v-if="edition.stateId == 3 && $IsUserInRole('VertragsmanagementVerwaltung')"
                class="editionAction"
              >
                <edition-deactivation
                  :contract-id="contractId"
                  :version-id="versionId"
                  :edition-to-deactivate="edition.editionId"
                />
              </div>
            </div>
            <div>
              <EditionMinimumSalaryValidation
                :contract-id="contractId"
                :version-id="versionId"
                :edition-id="edition.editionId"
                :disable-validation="edition.stateId != 1"
              />
            </div>
          </td>
        </tr>
        <tr :key="`${index}-2`">
          <td />
          <td
            colspan="3"
            class="whitespace-preline"
          >
            {{ edition.kommentar }}
          </td>
          <td />
        </tr>
      </template>
    </table>
    <b-modal
      id="deleteEdition"
      ref="deleteEdition"
      hide-footer
      title="Edition löschen"
      no-fade
      :no-close-on-backdrop="isDeleting"
    >
      <u-loader
        v-if="isDeleting"
        text="Edition wird gelöscht..."
      />
      <div v-else>
        <u-error-handling
          v-if="deleteErrorObject"
          :error-object="deleteErrorObject"
        />
        <div class="d-block mb-4">
          Sind Sie sicher, dass Sie diese Edition löschen möchten?
        </div>
        <b-button
          variant="success"
          :disabled="isDeleting"
          @click="deleteEdition()"
        >
          Ok
        </b-button>
        <b-button
          class="ml-2"
          variant="danger"
          :disabled="isDeleting"
          @click="hideModal('deleteEdition')"
        >
          Abbrechen
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { UniaGAVConstants } from "@/assets/configuration/constants.js";
import { addItemToMerkliste } from "@/helpers/BookmarksHelper.js";
import { GetVersionInformation } from "@/services/contract.service.js";
import { DeleteEdition, SetEditionInactive, GetGavServiceUrl } from "@/services/contract.edition.service.js";
import EditionPublication from "./EditionPublication.vue";
import EditionDeactivation from "./EditionDeactivation.vue";
import EditionMinimumSalaryValidation from "./EditionMinimumSalaryValidation.vue";

export default {
  components: { EditionPublication, EditionDeactivation, EditionMinimumSalaryValidation },
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    versionIdId: {
      type: Number,
      default: 0,
    },
    allEditions: {
      type: Array,
      default: () => [],
    },
    currentEditionId: {
      type: Number,
      default: 0,
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      UniaGavConstants: UniaGAVConstants,
      BookmarkSuccess: false,
      BookmarkFailure: false,
      currentVersionName: "",
      errorObject: null,
      deleteErrorObject: null,
      editionToDeactivate: null,
      isDeleting: false,
      editionToDelete: null,
    };
  },
  created() {
    GetVersionInformation(
      this.contractId,
      this.versionId,
      (result) => {
        var versionTitle = result.versionContents.filter(function (item) {
          return item.language == "de-CH";
        });

        // By Default, we use the german name, otherwise, just the first one
        if (versionTitle.length == 1) {
          this.currentVersionName = versionTitle[0].value;
        } else if (result.versionContents.length > 0) {
          this.currentVersionName = result.versionContents[0].value;
        }
      },
      (error) => {
        this.isLoading = false;
        this.errorObject = error;
      },
    );
  },
  methods: {
    openPreview(editionId, edition) {
      this.errorObject = null;

      var date = "";

      // if the edition is in Edit, we first check wheter or not ave is in the future
      // if yes, we use that date for the preview
      // if no, we check if the valid from date is in the future, if yes, we use it for the preview
      // otherwise, we dont do anything -> todays date is used for the preview
      // moment.diff gives a negative number if the compare-date
      if (edition.stateId == 1) {
        var aveDate = this.$moment(edition.aveStart);
        var validFromDate = this.$moment(edition.versionValidFrom);

        if (this.$moment().diff(aveDate) < 0) {
          date = this.$moment(edition.aveStart).format("DD.MM.YYYY");
        } else if (this.$moment().diff(validFromDate) < 0) {
          date = this.$moment(edition.versionValidFrom).format("DD.MM.YYYY");
        }
      }

      GetGavServiceUrl(
        (success) => {
          window.open(
            `${success}/gav/${this.contractId}/version/${this.versionId}/vertrag/${editionId}?preview=true${
              date ? "&date=" + date : ""
            }`,
            "_blank",
          );
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    setEditionInactive() {
      this.errorObject = null;

      SetEditionInactive(
        this.contractId,
        this.versionId,
        this.editionToDeactivate,
        () => {
          this.hideModal("setEditionInactive");
          this.$emit("editionsChanged");
        },
        (error) => {
          this.errorObject = error;
          this.hideModal("setEditionInactive");
        },
      );
    },
    deleteEdition() {
      let that = this;
      this.isDeleting = true;
      this.errorObject = null;

      DeleteEdition(
        this.contractId,
        this.versionId,
        this.editionToDelete,
        () => {
          that.$emit("editionsChanged");
          this.$eventBus.$emit("editionsChanged");
          that.hideModal("deleteEdition");
          that.isDeleting = false;

          this.$router.push({
            path: `/contract-overview/${this.contractId}/${this.versionId}`,
          });
        },
        (error) => {
          that.deleteErrorObject = error;
          that.isDeleting = false;
        },
      );
    },
    addEditionToBookmarks(contractName, versionNumber, editionNumber, contractNumber) {
      this.BookmarkSuccess = false;
      this.BookmarkFailure = false;

      var result = addItemToMerkliste(contractName, versionNumber, editionNumber, contractNumber);

      if (result == 1) {
        // Inform the Bookmark component that something changed.
        this.$eventBus.$emit("bookmarkAdded");
        this.BookmarkSuccess = true;
      } else {
        this.BookmarkFailure = true;
      }
    },
  },
};
</script>

<style scoped>
.editionTable {
  font-size: small;
}

.fixedAlert {
  position: fixed;
  top: 55px;
  z-index: 100;
  left: 25%;
  width: 50%;
}

.editionTable tr:nth-child(2n + 1) {
  border-bottom: 1px solid #ddd;
  font-style: italic;
  color: #888;
}
.editionTable th {
  padding-right: 30px;
}
.editionTable th:nth-child(2) {
  width: 30%;
}
.editionTable th:nth-child(3) {
  width: 30%;
}
.editionTable th:nth-child(4) {
  width: 30%;
}
.editionTable tr:nth-child(2n + 1) td:first-child {
  border-bottom: 2px solid white;
}
.editionTable tr:nth-child(2n + 1) td {
  padding-bottom: 10px;
  padding-top: 10px;
}
.editionTable tr:nth-child(2n) td {
  padding-top: 10px;
}

.editionTable tr:nth-child(2n) td:first-child {
  font-weight: bold;
}

.editionAction {
  width: 25px;
  height: 25px;
  margin: 2px;
  float: left;
  font-size: 16px;
}
.editionActionWrapper {
  width: 170px;
}
.whitespace-preline {
  white-space: pre-line;
}

/* Add this new rule to top-align all table cells */
.editionTable td {
  vertical-align: top;
}

.editionTable .v-checkbox {
  height: 16px !important; /* Force smaller height */
  min-height: 16px !important;
}

.editionTable .v-checkbox .v-input__control {
  height: 16px;
}

.checkbox-row {
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.compact-checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
  flex-shrink: 0;
  margin-left: auto;
}

.checkbox-row span {
  min-width: 220px;
}
.compact-questionmark {
  margin-left: 10px;
  flex-shrink: 0;
}
</style>
